module.exports = __webpack_public_path__ + "static/media/Kept - o2.dc1b075e.png";